/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Lightbulb';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const LightbulbIcon = withMuiAdapter(Base, 'Lightbulb');
